import { ColumnBodyOptions, ColumnProps } from "primereact/column";

type BodyRendererFunction = Extract<
  ColumnProps['body'],
  (data: unknown, options: ColumnBodyOptions) => React.ReactNode
>

export const alertLessThan =  (value: number) : BodyRendererFunction => {
  return (r,opt) => {
    const renderValue = opt.field ? r[opt.field] : r;
    return (
      <span style={{color: renderValue < value ? 'red' : 'black'}}>
        {renderValue}
      </span>
    )
  }
};

export const alertGreaterThan =  (value: number) : BodyRendererFunction => {
  return (r,opt) => {
    const data = r.data ? r.data : r;
    const renderValue = opt.field ? data[opt.field] : data;
    return (
      <span style={{color: renderValue > value ? 'red' : 'black'}}>
        {renderValue}
      </span>
    )
  }
}
